import { useMarketSummary } from "../../../../hooks/useMarketSummary";
import { Market } from "../../../../../../types/workspace";
import { useWorkspaceStore } from "../../../../../../store/workspace/WorkspaceStore";
import { useConfigurationFiltersWithMatch } from "./useConfigurationFiltersWithMatch";

export const useCurrentCustomerCounts = () => {
  const workspace = useWorkspaceStore((state) => state.draft);
  const localizeInstalls = useWorkspaceStore(
    (state) => state.draft?.configuration?.localizeInstalls ?? true
  );

  const tam = useMarketSummary({
    companyFilters: useConfigurationFiltersWithMatch(workspace, Market.TAM),
    spendCategoryWeights: workspace?.configuration.tam.spendCategoryWeights,
    localizeInstalls,
  });

  const sam = useMarketSummary({
    companyFilters: useConfigurationFiltersWithMatch(workspace, Market.SAM),
    spendCategoryWeights: workspace?.configuration.tam.spendCategoryWeights,
    localizeInstalls,
  });

  const som = useMarketSummary({
    companyFilters: useConfigurationFiltersWithMatch(workspace, Market.SOM),
    spendCategoryWeights: workspace?.configuration.tam.spendCategoryWeights,
    localizeInstalls,
  });

  return {
    tamCustomers: tam.companyCount,
    samCustomers: sam.companyCount,
    somCustomers: som.companyCount,
    loading: tam.loading || sam.loading || som.loading,
  };
};
